/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Badge_Lowestever1Inputs */

const he_item_stats_badge_lowestever1 = /** @type {(inputs: Item_Stats_Badge_Lowestever1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיא נמוך`)
};

const en_item_stats_badge_lowestever1 = /** @type {(inputs: Item_Stats_Badge_Lowestever1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest ever`)
};

/**
* | output |
* | --- |
* | "Lowest ever" |
*
* @param {Item_Stats_Badge_Lowestever1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_badge_lowestever1 = /** @type {((inputs?: Item_Stats_Badge_Lowestever1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Badge_Lowestever1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_badge_lowestever1(inputs)
	return en_item_stats_badge_lowestever1(inputs)
});
export { item_stats_badge_lowestever1 as "item_stats_badge_lowestEver" }